import { f as r } from "./index743.mjs";
var a = r, c = a([].slice);
export {
  c as a
};
